export type Status = 'todo'|'doing'|'done'|'pending'|'in_progress'|'completed';

export function statusLabel(status: Status, locale: 'sk'|'en'='sk') {
  const map = {
    todo:      { sk: 'Nová',         en: 'New' },
    doing:     { sk: 'Rozpracovaná', en: 'In progress' },
    done:      { sk: 'Dokončená',    en: 'Done' },
    pending:   { sk: 'Čaká na spracovanie', en: 'Pending' },
    in_progress: { sk: 'Rozpracované', en: 'In progress' },
    completed: { sk: 'Dokončené',    en: 'Completed' },
  } as const;
  return map[status]?.[locale] ?? String(status);
}


